import styled from '@emotion/styled';
import { Tabs, TabPanels, TabPanel, Box, Flex } from '@node-real/uikit';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { ColoredWarningIcon } from '@node-real/icons';
import { MobileTab, mobileMedia, useResponsive } from '@op-bridge/bridge-core';

import { DepositHistory } from '../../components/history/DepositHistory';
import { WithdrawHistory } from '../../components/history/WithdrawHistory';
import { WarningText } from '../../components/style';
import { usePausedStatus } from '../../hooks';
import { reportEvent, GA_MAP } from '../../utils/ga';
import { TabListHistory } from '../../components/history/TabListHistory';
// import { NET_ENV } from '../../env';
interface HistoryProps {
  type: string;
}

const TAB_MAP = ['deposit', 'withdraw'];

const Index = (props: HistoryProps) => {
  const { type } = props;
  const [activeKey, setActiveKey] = useState(type);
  const router = useRouter();
  const { pausedStatus } = usePausedStatus();
  const { isMobile } = useResponsive();

  useEffect(() => {
    if (type && TAB_MAP.includes(type)) {
      setActiveKey(type);
    }
  }, [type]);

  const onChange = async (key: string | number) => {
    const tabName = String(key);
    if (tabName === 'deposit') {
      reportEvent({
        name: GA_MAP.historyDepositTab,
        data: { name: 'Deposit Tab' },
      });
    } else {
      reportEvent({
        name: GA_MAP.historyWithdrawTab,
        data: { name: 'Withdraw Tab' },
      });
    }
    router.replace(`?type=${tabName}`);
  };

  return (
    <>
      {isMobile && <MobileTab />}
      <CustomTabs activeKey={activeKey} onChange={onChange}>
        <TabListHistory />
        <TabPanels mt={[16, 12, 12]}>
          {activeKey === TAB_MAP[0] && (
            <TabPanel panelKey={TAB_MAP[0]}>
              <DepositHistory />
            </TabPanel>
          )}
          {activeKey === TAB_MAP[1] && (
            <TabPanel panelKey={TAB_MAP[1]}>
              {pausedStatus === true && (
                <Box
                  maxWidth={1181}
                  margin={'-12px auto 0'}
                  p={['16px 12px', '0 24px']}
                  mb={[0, -8]}
                >
                  <Flex
                    flexDirection={'row'}
                    alignItems={'center'}
                    p={'8px 12px'}
                    borderRadius={[4, 0]}
                    background={'scene.orange.background'}
                  >
                    <ColoredWarningIcon w={16} h={16} color={'scene.orange.normal'} mr={4} />
                    <WarningText> Withdrawal function is temporarily suspended.</WarningText>
                  </Flex>
                </Box>
              )}
              <WithdrawHistory />
            </TabPanel>
          )}
        </TabPanels>
      </CustomTabs>
    </>
  );
};

export default Index;

export async function getServerSideProps(context: any) {
  const { type } = context?.query;
  const rawType = TAB_MAP?.includes(type) ? type : 'deposit';

  return { props: { type: rawType } };
}

const CustomTabs = styled(Tabs)`
  width: 100%;
  ${mobileMedia} {
    width: calc(100% - 32px);
    margin: 0 16px;
    background: ${(props: any) => props.theme.colors.bg.table};
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
`;
